// extracted by mini-css-extract-plugin
module.exports = {"title":"home-section_title__8l7Ln","section":"home-section_section__hcnaR","dark":"home-section_dark__xyMMv","blue":"home-section_blue__UXVB3"};